import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { boardZones } from '@/mocks/home';

export default function BoardZones() {
  return (
    <section id="boards" className="border-y border-background-200 bg-secondary-950 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-900 px-3 py-1 text-xs tracking-wide text-secondary-200">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-layout-grid-line text-[13px]"></i>
              </span>
              社区分区
            </span>
            <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              <span className="mr-2 inline-block h-5 w-1.5 translate-y-[2px] rounded-full bg-accent-400 md:h-6"></span>
              挑个分区，坐下来慢慢聊
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-50/70 md:text-base">
              六个分区各管一摊：从新入库的合集到老帖挖坟，想找的方向基本都能对上号。
            </p>
          </div>
          <button
            type="button"
            className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-50/25 bg-background-50/10 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20"
          >
            进入全部分区
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {boardZones.map((zone, index) => (
            <Reveal key={zone.id} delay={index * 60}>
              <div className="group flex h-full cursor-pointer flex-col rounded-lg border border-secondary-800 bg-secondary-900 p-5 transition-colors hover:border-accent-400/60">
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-800 transition-colors group-hover:bg-accent-500">
                    <i
                      className={`${zone.icon} text-xl text-accent-300 transition-colors group-hover:text-foreground-950`}
                    ></i>
                  </span>
                  <span className="flex items-center gap-1 rounded-md bg-primary-500/15 px-2 py-1 text-xs font-medium text-primary-300">
                    <span className="flex h-3 w-3 items-center justify-center">
                      <i className="ri-arrow-up-line text-[11px]"></i>
                    </span>
                    今日 +{zone.today}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-base font-bold text-background-50 md:text-lg">{zone.name}</h3>
                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-background-50/60">{zone.desc}</p>

                <div className="mt-4 flex items-center justify-between border-t border-secondary-800 pt-3 text-xs text-background-50/60">
                  <span>{zone.posts} 条主题</span>
                  <span className="flex items-center gap-1 text-accent-300">
                    进入分区
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-arrow-right-up-line text-[13px]"></i>
                    </span>
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}